export enum facebookConversionEvents {
  viewContent = 'view_content',
  purchase = 'purchase',
  lead = 'lead',
  schedule = 'schedule',
}
